import FilterPagesGeneral from "../../components/FilterPagesGeneral";

export default function DiscountRequests() {
  const filterMethods = ["requester", "discount_name", "status"];

  return (
    <FilterPagesGeneral
      pageName={"discount_request"}
      filterMethods={filterMethods}
    />
  );
}
